import type { StaticDataRouteOption } from "@tanstack/react-router"

export const createProjectViewStaticData: StaticDataRouteOption = {}
